import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { BackButton } from "@/components/BackButton";
import { api, apiErr } from "@/lib/api";
import { mediaUrl } from "@/pages/Marketplace";
import { toast } from "sonner";
import { Eye, Trash2, Plus, Tag } from "lucide-react";

export default function MyAds() {
  const [ads, setAds] = useState(null);

  const load = () => api.get("/ads/mine").then((r) => setAds(r.data.ads)).catch(() => setAds([]));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this ad?")) return;
    try { await api.delete(`/ads/${id}`); toast.success("Ad deleted"); setAds((a) => a.filter((x) => x.id !== id)); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A14] text-slate-200">
      <Header />
      <div className="max-w-4xl mx-auto px-6 py-10">
        <BackButton className="mb-6" />
        <div className="flex items-center justify-between mb-8">
          <h1 className="font-head font-900 text-3xl text-slate-50">My Ads</h1>
          <Link to="/market/new" data-testid="myads-post-btn" className="inline-flex items-center gap-2 font-arcade text-lg px-5 py-2.5 bg-[#A78BFA] text-black border border-[#A78BFA] hover:-translate-y-0.5 transition-transform duration-200"><Plus className="w-4 h-4" /> NEW AD</Link>
        </div>

        {ads === null ? <p className="text-slate-500">Loading…</p> : ads.length === 0 ? (
          <div className="text-center py-16" data-testid="myads-empty">
            <p className="text-slate-400 mb-4">You haven't posted any ads yet.</p>
            <Link to="/market/new" className="font-arcade text-lg text-[#A78BFA]">CREATE YOUR FIRST AD →</Link>
          </div>
        ) : (
          <div className="space-y-4" data-testid="myads-list">
            {ads.map((ad) => (
              <div key={ad.id} data-testid={`myad-${ad.id}`} className="flex gap-4 rounded-2xl border border-white/10 bg-[#11111A] p-4">
                <div className="w-24 h-24 rounded-xl bg-white/5 overflow-hidden shrink-0">
                  {ad.image_urls?.[0] ? <img src={mediaUrl(ad.image_urls[0])} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-slate-600"><Tag className="w-6 h-6" /></div>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] uppercase tracking-wider text-[#A78BFA]">{ad.category}</span>
                    <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-emerald-400/10 text-emerald-300">{ad.status}</span>
                  </div>
                  <Link to={`/market/${ad.id}`} className="font-head font-700 text-lg text-slate-50 hover:text-[#A78BFA] transition-colors duration-200 line-clamp-1">{ad.title}</Link>
                  <p className="text-sm text-slate-400 line-clamp-1">{ad.description}</p>
                  <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
                    <span className="inline-flex items-center gap-1"><Eye className="w-3 h-3" /> {ad.views} views</span>
                  </div>
                </div>
                <button data-testid={`delete-ad-${ad.id}`} onClick={() => del(ad.id)} className="self-start p-2 rounded-lg border border-rose-400/30 text-rose-300 hover:bg-rose-400/10 transition-colors duration-200"><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
